import Vue from 'vue'
import VueRouter from 'vue-router'
import SociView from '../views/SociHelper.vue'
import LoginView from '../views/Login.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/SociHelper',
    name: 'SociHelper',
    component: SociView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
